<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/t0x818/tc-custom/9781504096621.jpg?1723231327977" alt="This image is the cover for the book Her Best Friend's Husband"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Her Best Friend's Husband
      </h1>
      <p class="bookDescription body article font2">
        <b>A wrenching new novel of guilt, good intentions, and terrifying twists by the acclaimed author of <i>Casual Cruelties</i>.</b><br/><br/> On paper, Claire has it all. A long and happy marriage, two lovely daughters, and a big house in the country. But she’s hiding a secret . . .<br/><br/> Struggling with issues from her school days, Claire finds her life beginning to unravel as she seeks comfort in the arms of her best friend’s husband. When she learns of a school reunion, she sees her opportunity to put things right.<br/><br/> But even the best laid plans can go awry, and not everyone is willing to forgive and forget . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alison Irving
      </h2>
      
      <p class="authorDescription body article">I was born in Northern Ireland and studied physiotherapy at the University of Ulster, where I met my husband in first term of first year. The next fifteen years were spent in England, then Scotland following his job. Eventually we moved home to a small village outside Belfast, where we live with our two children. I still work as a physio in a local hospice and love to explore our fantastic coastline, make jewellery that I sell worldwide, and put the world to rights with my book club. Sometimes we even read books.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?27d5bd80